import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage-angular";

@Injectable({
    providedIn: "root"
})
export class RedirectUrlService {
    private static readonly REDIRECT_URL_KEY = "redirectUrl";
    private redirectUrl: string | null = null;

    constructor(private storage: Storage) {}

    async set(url: string): Promise<void> {
        this.redirectUrl = url;
        await this.storage.set(RedirectUrlService.REDIRECT_URL_KEY, url);
    }

    setInMemory(url: string | null): void {
        this.redirectUrl = url;
    }

    getInMemory(): string | null {
        return this.redirectUrl;
    }

    async get(): Promise<string | null> {
        const storedUrl = await this.storage.get(
            RedirectUrlService.REDIRECT_URL_KEY
        );
        return storedUrl || this.redirectUrl;
    }

    async remove(): Promise<void> {
        this.redirectUrl = null;
        await this.storage.remove(RedirectUrlService.REDIRECT_URL_KEY);
    }

    async getAndRemove(): Promise<string | null> {
        const url = await this.get();
        if (url) {
            await this.remove();
        }
        return url;
    }
}
